import $axios from '@/helpers/axios-instance';

const baseUrl = process.env.API_SCHOOLS_URL;

export default {
  getNews() {
    return $axios.get('api/v1/website/news', { baseURL: baseUrl });
  },
  getPagedNews(paging) {
    return $axios.get(
      `api/v1/website/news/page/${paging.page}/pagesize/${paging.pageSize}`,
      {
        baseURL: baseUrl,
      },
    );
  },
  createNews(newsItem) {
    return $axios.post('api/v1/website/news', newsItem, { baseURL: baseUrl });
  },
  updateNews(newsItem) {
    return $axios.put(`api/v1/website/news/${newsItem.id}`, newsItem, {
      baseURL: baseUrl,
    });
  },
  deleteNews(newsItem) {
    return $axios.delete(`api/v1/website/news/${newsItem.id}`, {
      baseURL: baseUrl,
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/website.js